/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListIssuanceProfilesSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type ListIssuanceProfilesRequest = {
  /**
   * The sign-in.
   */
  userSessionIssuerId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type ListIssuanceProfilesSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const ListIssuanceProfilesSecurity$outboundSchema: z.ZodMiniType<
  ListIssuanceProfilesSecurity$Outbound,
  ListIssuanceProfilesSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function listIssuanceProfilesSecurityToJSON(
  listIssuanceProfilesSecurity: ListIssuanceProfilesSecurity,
): string {
  return JSON.stringify(
    ListIssuanceProfilesSecurity$outboundSchema.parse(
      listIssuanceProfilesSecurity,
    ),
  );
}

/** @internal */
export type ListIssuanceProfilesRequest$Outbound = {
  user_session_issuer_id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const ListIssuanceProfilesRequest$outboundSchema: z.ZodMiniType<
  ListIssuanceProfilesRequest$Outbound,
  ListIssuanceProfilesRequest
> = z.pipe(
  z.object({
    userSessionIssuerId: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      userSessionIssuerId: "user_session_issuer_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
    });
  }),
);

export function listIssuanceProfilesRequestToJSON(
  listIssuanceProfilesRequest: ListIssuanceProfilesRequest,
): string {
  return JSON.stringify(
    ListIssuanceProfilesRequest$outboundSchema.parse(
      listIssuanceProfilesRequest,
    ),
  );
}
